// Institution `kind` enum — mirrors the backend Institution.Kind choices
// (apps/backend/core/models.py). The string values ARE the wire contract; the
// UI maps each to an es-MX / en-US label via `institutions:kind.<value>`.

export const INSTITUTION_KINDS = ["empresa", "sistema_publico", "otro"] as const
export type InstitutionKind = (typeof INSTITUTION_KINDS)[number]
